import Station from '@/models/Station'

export default class Stations {
  constructor(public stations: Station[]) {}

  findById(id: string) {
    return this.stations.find(station => station.stationId === id)
  }

  rainStations() {
    return this.stations.filter(station => !station.fieldId.includes('waterLevel'))
  }

  waterStations() {
    return this.stations.filter(station => station.fieldId.includes('waterLevel'))
  }

  whereByType(type: string) {
    return type === 'rain' ? this.rainStations() : this.waterStations()
  }
}
